// export type CSVRow = Record<string, string | number | boolean | Date>;

import { FormatDateTime } from "./FormatUtil";

export async function ExportCSV(
  columnDataList: CsvColumnData[],
  rows: Record<string, unknown>[],
  fileName: string
) {
  const delimiter = ";";
  const newline = "\r\n";

  let sContent = "";
  for (const cd of columnDataList) {
    sContent += cd.header + delimiter;
  }
  sContent += newline;

  for (const row of rows) {
    for (const cd of columnDataList) {
      let value = row[cd.property];
      if (cd.formatter) {
        value = cd.formatter(value as never);
      }
      sContent += (value || "") + delimiter;
    }
    sContent += newline;
  }

  const blob = new Blob([sContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName + ".csv";
  link.click();
}

export interface CsvColumnData {
  header: string;
  property: string;
  formatter?: (value: never) => string;
}

export function FormatDateTimeForCsv(dateStr?: string | null) {
  let formattedDate = FormatDateTime(dateStr);
  return formattedDate.replace(",", ""); // comma between date and time can be interpreted as column separator
}

export function FormatPriceForCsv(price?: number | null) {
  if (typeof price !== "number") return "";

  return price.toFixed(2) + " \u20AC";
}
